import { render, staticRenderFns } from "./ticketStats.vue?vue&type=template&id=310a78f6&scoped=true"
import script from "./ticketStats.vue?vue&type=script&lang=js"
export * from "./ticketStats.vue?vue&type=script&lang=js"
import style0 from "./ticketStats.vue?vue&type=style&index=0&id=310a78f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a78f6",
  null
  
)

export default component.exports